/**
 * Loads all license definitions from src/assets/licenses/*.json.
 * Uses Vite's import.meta.glob for static analysis and bundling.
 * @returns {import('../types/license').License[]}
 */
const licenseModules = import.meta.glob('../assets/licenses/*.json', {
  eager: true
});

const licenses = Object.values(licenseModules).map((mod) => ({
  ...(mod?.default ?? mod)
}));

export default licenses;
